import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const InboxSlashIcon = (props: IconProps) => (
  <Icon height="20px" width="20px" viewBox="0 0 20 20" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.84502 0.488037L1.6665 1.66655L2.98944 2.98949C2.68735 3.29157 2.49984 3.70825 2.49984 4.1666V15.8333C2.49984 16.7499 3.2415 17.4999 4.1665 17.4999H15.8332C16.2915 17.4999 16.7082 17.3124 17.0103 17.0103L18.1657 18.1657L19.3442 16.9872L2.84502 0.488037ZM15.8332 15.8332L13.3332 13.3333H12.8832C12.2998 14.3249 11.2415 14.9999 10.0082 14.9999C8.77484 14.9999 7.70817 14.3249 7.13317 13.3333H4.1665V15.8333H15.8332V15.8332ZM11.6748 11.6749L4.16655 4.1666H4.1665V11.6666H8.3415C8.3415 12.5833 9.0915 13.3333 10.0082 13.3333C10.9221 13.3333 11.6703 12.5878 11.6748 11.6749ZM17.4998 12.8787V4.16655C17.4998 3.24988 16.7498 2.49988 15.8332 2.49988H7.42629L9.04394 4.16655H15.8332V11.1615L17.4998 12.8787Z"
    />
  </Icon>
);

export default memo(InboxSlashIcon);
